/*
*   File : creator-detail.js
*   Author : https://evoqins.com
*   Description : Creator detail page
*   Integrations : NA
*   Version : 1.0.0
*/

import React, { useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Modal } from 'bootstrap';
import { toast } from 'react-toastify';


//Style
import style from "../../Styles/Component/explore.module.scss";

//Custom components
import { Icon } from '../../Component/Icon';
import { Chip, EmptyScreen, Loader } from '../../Component/Others';
import { AlphaBasketSlider } from '../../Component/Slider';
import { ConnectBrokerModal } from '../../Component/Modal';
import { AlphaBasketCard, CategoryTab } from '../../Component/Cards';
import { APIService } from '../../Service';
import { TextButton } from '../../Component/Buttons';
import { _scrollToTop } from '../../Helper';

// Assets
import EmptyData from "../../Assets/Images/EmptyScreen/empty-data.webp";

const PRODUCT_TAB = [
    {
        id: 1,
        label: "alphaBasket",
    },
    {
        id: 2,
        label: "alphaBasket pro",
    },
    // {
    //     id: 3,
    //     label: "alphaStocks",
    // },
    // {
    //     id: 4,
    //     label: "alphaOptions",
    // },
    // {
    //     id: 5,
    //     label: "alphaMF",
    // },
];

const CreatorDetail = () => {
    const swiperRef = useRef(null);
    const navigate = useNavigate();
    const { state } = useLocation();
    const [creatorDetail, setCreatorDetail] = useState({});
    const [connectModal, setConnectModal] = useState(false);
    const [categoryTab, setCategoryTab] = useState(1);
    const [dataLoading, setDataLoading] = useState(true);
    const [selectedTabProducts, setSelectedTabProducts] = useState([]);

    useEffect(() => {
        // API call
        _getCreatorDetail();

        // Scroll the page to top
        _scrollToTop();
    }, []);

    useEffect(() => {
        if (connectModal === true) {
            const connect_modal = new Modal(document.getElementById('connect-modal'));
            connect_modal.show();
        }
    }, [connectModal]);

    // handle back
    const _handleBack = () => {
        navigate("/explore", {
            state: {
                tab_index: 2,
                category_tab: 1
            }
        });
    };

    // handle previous slider 
    const _handlePrev = () => {
        if (swiperRef.current && swiperRef.current.swiper) {
            swiperRef.current.swiper.slidePrev();
        }
    };

    // handle next slider 
    const _handleNext = () => {
        if (swiperRef.current && swiperRef.current.swiper) {
            swiperRef.current.swiper.slideNext();
        }
    };

    // handle detail page
    const _handleBasketDetail = (strategy_id) => {

        // setConnectModal(true);

        navigate("/explore/strategy-detail", {
            state: {
                "strategy_id": Number(strategy_id),
            }
        });
    };

    // handle category tab change
    const _handleCategoryTab = (id) => {
        if (id == 1) {
            setSelectedTabProducts(creatorDetail.all_products.alpha_basket.products);
        } else if (id == 2) {
            setSelectedTabProducts(creatorDetail.all_products.alpha_basket_pro.products);
        }
        setCategoryTab(id);
    };


    // ========== API CAllS ========== //
    // Get product creator detail
    const _getCreatorDetail = async () => {

        let url = "products/creator-detail";
        let data = {
            "tenant_id": state.creator_id // 1581586302
        };

        const response = await APIService(url, data);

        if (response.status_code === 200) {
            setCreatorDetail(response.data);
            setSelectedTabProducts(response.data.all_products.alpha_basket.products);
        } else {
            navigate("/");
            toast.dismiss();
            toast.error("No data found");
        }
        setDataLoading(false);
    };

    return (
        <>

            {
                dataLoading ?
                    <Loader wrapperClassName="min-vh-100 margin-200px-top" />
                    :
                    <section className={`${style.e_creator_detail_wrapper} pb-5`}>
                        <div className={`${style.e_top_section} border-radius-16 p-3 p-sm-4`}>
                            <Icon icon="back-arrow"
                                size="28px"
                                className=" cursor-pointer"
                                onPress={_handleBack} />

                            <div className='padding-18px-tb d-flex gap-3 flex-wrap'>
                                <img src={creatorDetail.creator_logourl}
                                    draggable={false}
                                    width={48}
                                    height={48}
                                    className='border-radius-4 object-fit-contain bg-white p-1 bg-white'
                                    alt='logo' />

                                <div>
                                    <h6 className='e-font-16-res margin-2px-bottom e-alt-font-lato e-font-18 e-text-white e-font-weight-700 line-height-24px'>
                                        {creatorDetail.creator_name}
                                    </h6>
                                    <p className='mb-0 e-alt-font-lato e-font-12 e-text-pale-lavender e-font-weight-600 line-height-18px'>
                                        SEBI REGISTERED
                                        <span className=' e-font-14 e-text-white e-font-weight-600 line-height-20px'>
                                            {" "} {creatorDetail.sebi_registered_number}
                                        </span>
                                    </p>
                                </div>
                            </div>

                            {/* INVESTMENT STRATEGIES  */}
                            <h6 className='mb-2 e-alt-font-lato e-font-10 e-text-pale-lavender e-font-weight-600 line-height-18px'>
                                INVESTMENT STRATEGIES
                            </h6>
                            {/* Chip */}
                            <div className='d-flex align-items-center gap-2 flex-wrap'>
                                {
                                    creatorDetail.investment_strategies.map((tag, key) => (
                                        <div key={key}>
                                            <Chip label={tag}
                                                className="e-text-chinese-black e-border-0-5px-gainsboro e-bg-lavender-light" />
                                        </div>
                                    ))
                                }
                                {/* 
                                {
                                    creatorDetail.investment_strategies.length > 3 &&
                                    // <div>
                                    //     <span className='cursor-pointer e-alt-font-lato e-text-white e-font-12 e-font-weight-600 line-height-24px'>
                                    //         +{creatorDetail.investment_strategies.length - 3} more
                                    //     </span>
                                    // </div>
                                } */}
                            </div>
                        </div>


                        {/* About */}
                        <div className='row pt-4 row-gap-3'>
                            <div className='col-12 col-md-7 col-lg-8'>
                                <h6 className='mb-2 e-primary-font-clash-display e-text-black e-font-16 e-font-weight-500 line-height-24px'>
                                    About
                                </h6>
                                <p className='e-font-14-res mb-0 e-alt-font-lato e-text-outer-space e-font-16 e-font-weight-400 line-height-26px'>
                                    {creatorDetail.creator_description}
                                </p>
                            </div>
                            {/* Managed by  details */}
                            <div className='col-4'>
                                <div className={`${style.e_managed_by_wrapper} border-radius-16 e-border-1px-lavender-light p-3`}>
                                    <h6 className='mb-3 e-primary-font-clash-display e-text-primary-color e-font-16 e-font-weight-500 line-height-20px'>
                                        Managed by
                                    </h6>
                                    <div className='d-flex gap-2 align-items-center'>

                                        <img src={creatorDetail.manager_image}
                                            draggable={false}
                                            width={64}
                                            height={64}
                                            className={`${creatorDetail.manager_image ? "" : "d-none"}`}
                                            alt='manager' />
                                        <div>
                                            <p className='mb-2 e-alt-font-lato e-text-black e-font-18 e-font-weight-600 line-height-20px'>
                                                {creatorDetail.manager_name}
                                            </p>
                                            <p className='mb-0 e-alt-font-lato e-text-outer-space e-font-14 e-font-weight-400 line-height-18px'>
                                                {creatorDetail.manager_experience} years experience
                                            </p>
                                        </div>
                                    </div>
                                    <p className='pt-3 margin-12px-bottom e-alt-font-lato e-text-outer-space e-font-14 e-font-weight-400 line-height-22px'>
                                        {creatorDetail.manager_description}
                                    </p>
                                    <TextButton name="View all" />
                                </div>
                            </div>
                        </div>

                        {/* Popular Products */}
                        {
                            creatorDetail.popular_baskets && creatorDetail.popular_baskets.length !== 0 &&
                            <div className='pt-3'>
                                <div className='pb-3 d-flex justify-content-between align-items-center'>
                                    <h6 className='mb-0 e-primary-font-clash-display e-font-16 e-text-black e-font-weight-500 line-height-24px'>
                                        Popular Products
                                    </h6>

                                    {/* Slider arrows */}
                                    {
                                        creatorDetail.popular_baskets && creatorDetail.popular_baskets.length > 3 &&
                                        <div className='d-flex gap-12px'>
                                            <div className='w-32px-res h-32px-res border-radius-32 e-bg-magnolia e-border-0-5px-lavender-light p-2 cursor-pointer'
                                                onClick={_handlePrev}>
                                                <Icon icon="arrow-right"
                                                    size="16px"
                                                    color="#48464C"
                                                    className="e-rotate-180 d-flex h-14px-res" />
                                            </div>
                                            <div className=' w-32px-res h-32px-res border-radius-32 e-bg-magnolia e-border-0-5px-lavender-light p-2 cursor-pointer'
                                                onClick={_handleNext}>
                                                <Icon icon="arrow-right"
                                                    className="d-flex h-14px-res"
                                                    color="#48464C"
                                                    size="16px" />
                                            </div>
                                        </div>
                                    }
                                </div>

                                {/* Custom slider */}
                                <AlphaBasketSlider ref={swiperRef}
                                    data={creatorDetail.popular_baskets}
                                    handleClick={_handleBasketDetail} />
                            </div>
                        }



                        {/* All Products  */}
                        <div className='padding-40px-top'>
                            <h6 className='margin-12px-bottom e-primary-font-clash-display e-font-16 e-text-chinese-black e-font-weight-500 line-height-24px'>
                                All Products
                            </h6>
                            <div className='e-bg-magnolia-extra-light px-sm-3 padding-20px-tb e-padding-8px-tb-10px-lr-res '>
                                <div className='d-flex gap-3'>
                                    <CategoryTab data={PRODUCT_TAB}
                                        activeTab={categoryTab}
                                        handleTabChange={_handleCategoryTab} />
                                </div>
                            </div>

                            {/* AlphaBasket card */}
                            {
                                selectedTabProducts.length !== 0 ?

                                    <div className='row row-gap-3 padding-12px-top'>
                                        {selectedTabProducts.map((product, key) => (
                                            <div key={key} className='col-md-6'>
                                                <AlphaBasketCard product={product}
                                                    // category={product.strategy_type === "alpha-basket" ? "alphaBasket" : "alphaBasketPro"}
                                                    category={categoryTab}
                                                    handleClick={() => _handleBasketDetail(product.strategy_id)} />
                                            </div>
                                        ))}
                                    </div>
                                    :
                                    <EmptyScreen type={1}
                                        emptyScreenImage={EmptyData}
                                        description="There is no products to show, please try with different categories" />
                            }

                        </div>

                        {/* Connect broker modal */}
                        {connectModal === true &&
                            <ConnectBrokerModal
                                handleClose={() => setConnectModal(false)}
                                handleSuccess={() => navigate("/explore/strategy-detail")} />
                        }
                    </section >
            }

        </>

    )
}

export default CreatorDetail;
